import LocalizedStrings from "react-localization";

export const Localization = new LocalizedStrings({
    en : require("../assets/data/en.json"),
    es : require("../assets/data/es.json"),
})